<template>
  <div>
    <board-filter-link :filterData="filterData" :filterLayout="filterLayout"></board-filter-link>
    <board-empty-link :emptyLayout="emptyLayout" v-if="List.length === 0"></board-empty-link>
    <board-list-link :boardData="List" :listLayout="listLayout"  :total="total" v-else></board-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import BoardListLink from "@/components/board/BoardListLink";
import BoardEmptyLink from "@/components/board/BoardEmptyLink";
import PaginationLink from "@/components/board/PaginationLink";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import alertMixins from "@/mixins/alertMixins";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import BoardFilterLink from "@/components/board/BoardFilterLink";
import util from "@/mixins/util";

const {filterConfig} = boardFilterUtil;

export default {
  name: "BoardListComponent",
  mixins: [filterMixins, listMixins, boardFilterUtil, boardTemplateUtil],
  components: {BoardFilterLink, PaginationLink, BoardEmptyLink, BoardListLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      boardListSetData: this.setData,
    }
  },
  props: {
    boardType: '',
    searchData: {
      default: ''
    },
    boardName: '',
  },
  data() {
    return {
      listLayout: '',
      paginationLayout: '',
      emptyLayout: '',
      filterLayout: '',
      getFunc: '',
      pageRow: 0,
      listApiParamSet: {},
      filterData: {},
      filterSearch: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig);
    this.setParserType('url', this.$route.fullPath);

  },
  mounted() {
    this.settingFilter();
    this.getList(true)
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.emptyLayout = boardTemplateConfig.emptyLayout;
      this.paginationLayout = boardTemplateConfig.paginationLayout;
      this.filterLayout = boardTemplateConfig.filterLayout;

      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.getFunc = boardFilterConfig.getFunc;
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.pageRow = boardFilterConfig.pageRow

      if (boardFilterConfig.pageRow && boardFilterConfig.pageRow != this.filterSet.page.size) {
        this.pageRow = boardFilterConfig.pageRow;
        this.filterSet.page.size = boardFilterConfig.pageRow;
        this.pageClass.setterPage('size', this.pageRow);
      }

      let listOptions = {
        url: this.$api.$board[this.getFunc],
        defaultParams: this.listApiParamSet,
      }

      this.initList('api', listOptions);
      this.total = this.pageClass;
      console.log(this.pageClass.total)
    },
    setData(key, value) {
      this[key] = value;
    },
    settingFilter() {
      this.setFilter('su', this.searchData)
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
